function checkValidOp(op) {
  for (var i = 0; i < op.length; i++) {
    if (!Array.isArray(op[i].p)) throw new Error("Missing path");

    // Paths must be at least 2 elements long for [table, objectId]
    if (op[i].p.length < 2) throw new Error("Path too short");
  }
}

export default checkValidOp;
